module.exports = __webpack_public_path__ + "img/Olav_og_Kari_Norsk_billedbog_for_boern.0fa36d84.jpg";